import { render } from "./HistoricoPedidoEmAndamento.vue?vue&type=template&id=65404e41&scoped=true"
import script from "./HistoricoPedidoEmAndamento.vue?vue&type=script&lang=js"
export * from "./HistoricoPedidoEmAndamento.vue?vue&type=script&lang=js"

import "./HistoricoPedidoEmAndamento.vue?vue&type=style&index=0&id=65404e41&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65404e41"]])

export default __exports__